export default "__VITE_ASSET__DM8yEtot__"